module.exports = __webpack_public_path__ + "img/slide11-piece-14.5f4c399a.png";